export const acceptImageTypes = [
    {
        type: 'image/jpeg',
        name: 'JPEG'
    },
    {
        type: 'image/jpg',
        name: 'JPG'
    },
    {
        type: 'image/png',
        name: 'PNG'
    },
]
